import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { GMC_REALISATIONS } from "../lib/constants";
import ResponsiveImage from "./ResponsiveImage";

const HEADER_ANIM = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.7 },
};

const CARD_ANIM = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export default function Realisations() {
  return (
    <section
      id="realisations"
      data-testid="realisations-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          {...HEADER_ANIM}
          className="mb-16 max-w-3xl"
        >
          <div className="eyebrow mb-4">Notre savoir-faire</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-4">
            Réalisations
            <br />
            <em className="text-[#FF5A00] not-italic font-normal">signées GMC</em>
          </h2>
          <p className="text-neutral-400 text-lg">
            Chaque chantier reflète notre exigence : finitions soignées, matériaux nobles,
            résultat impeccable.
          </p>
        </motion.div>

        {/* Gallery */}
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-neutral-500 mb-6">
            Galerie projets premium
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {GMC_REALISATIONS.map((p, i) => (
              <motion.article
                key={p.title}
                {...CARD_ANIM}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`realisation-${i}`}
                className="group relative rounded-2xl overflow-hidden border border-white/10 bg-[#0a0a0a] hover:border-white/30 transition-all"
              >
                <div className="aspect-[4/5] overflow-hidden">
                  <ResponsiveImage
                    src={p.image}
                    alt={p.title}
                    eager={i < 3}
                    sizes="(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 33vw"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent pointer-events-none" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <h3 className="font-display text-xl text-white mb-1">{p.title}</h3>
                      <p className="text-sm text-neutral-300 line-clamp-2">{p.description}</p>
                    </div>
                    <div className="w-9 h-9 rounded-full bg-[#FF5A00] flex items-center justify-center shrink-0 group-hover:rotate-45 transition-transform">
                      <ArrowUpRight size={16} />
                    </div>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
